<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { mainMenu } from '../../../stores/store';
    import WarehouseList from './WarehouseList.svelte';
    import { currentMainFilter } from '../../../stores/filter';
    import FilterWarehouses from '../Filter/FilterWarehouses.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import type { Warehouse } from './Warehouse';
    import { features } from '../../shared/Features/features';

    let addMode = false;
    let showFilter: boolean = false;
    let warehouseCount: number = -1;

    function onListChange(w: Warehouse[]) {
        if (w.length != warehouseCount) {
            if (warehouseCount >= 0) {
                if ($features.feature_ux_improvements) {
                    let pageWarehousesItem = $mainMenu.items.find((i) => i.id == 'PageWarehouses');
                    if (pageWarehousesItem?.notification) {
                        pageWarehousesItem.notification.reload = true;
                        $mainMenu = $mainMenu;
                    }
                }
            }
            warehouseCount = w.length;
        }
    }

    onMount(() => {
        $mainMenu.currentPage = 'PageWarehouses';
        $currentMainFilter = FilterWarehouses;
    });
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio>
            <div slot="main-header">
                {$_('Warehouses')}
            </div>
            <div slot="main-search">
                {#if !addMode && showFilter}
                    <FilterWarehouses />
                {/if}
            </div>
            <div slot="main-buttons">
                <ButtonAddSomething
                    text={$_('Add warehouse')}
                    on:click={() => {
                        addMode = !addMode;
                    }}
                />
            </div>
        </TemplateHeaderTrio>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="overflow-y: auto; flex: 1; display: flex; flex-direction: column;">
        <div
            style="margin: 20px 0; overflow-y: auto; flex: 1; display: flex; flex-direction: column;"
        >
            <WarehouseList bind:showFilter bind:addMode onChange={onListChange}/>
        </div>
    </div>
</TemplateStandard>
